import React from 'react'

import { Form } from '_zari/core'

const RowTemplate = ({ combustiblesData, arrayActualSalidaInput, setArrayActualSalidaInput, arrayVentasRecuperadas, setArrayVentasRecuperadas }) => {
  const handleChange = React.useCallback(
    (e, indice) => {
      const valorObtenido = e.target.value
      setArrayActualSalidaInput(prev => {
        let nuevoArray = [...prev]
        nuevoArray[indice] = valorObtenido
        return nuevoArray
      })
    },
    [setArrayActualSalidaInput]
  )

  let salida = []

  for (let i = 0; i < combustiblesData.length; i++) {
    const infoFila = combustiblesData[i]
    let montoVentaRecuperada = 0
    for (let j = 0; j < arrayVentasRecuperadas.length; j++) {
      const ventaRecuperadaActual = arrayVentasRecuperadas[j]
      if (ventaRecuperadaActual.codigo === infoFila.combustible && ventaRecuperadaActual.lado === infoFila.lado) {
        montoVentaRecuperada = ventaRecuperadaActual.sumaTotal
      }
    }

    if (i === 0) {
      salida.push(
        <tr key={i}>
          <td align='center'>{infoFila.nombre}</td>
          <td align='center'>{infoFila.lado}</td>
          <td align='center'>{infoFila.combustible}</td>
          <td>
            <Form.InputText
              id={`saldo-actualId-${i}`}
              name={`saldo-actual-${i}`}
              value={arrayActualSalidaInput[i]}
              onChange={e => handleChange(e, i)}
            />
          </td>
          <td align='center'>{parseFloat(infoFila.saldoAnterior).toFixed(3)}</td>
          <td align='center'>
            {parseFloat(arrayActualSalidaInput[i] ? arrayActualSalidaInput[i] - infoFila.saldoAnterior : infoFila.saldoAnterior).toFixed(3)}
          </td>
          <td align='center'>{parseFloat(montoVentaRecuperada).toFixed(3)}</td>
          <td align='center'>
            {parseFloat(
              montoVentaRecuperada - (arrayActualSalidaInput[i] ? arrayActualSalidaInput[i] - infoFila.saldoAnterior  : infoFila.saldoAnterior)
            ).toFixed(3)}
          </td>
        </tr>
      )
    } else {
      salida.push(
        <tr key={i}>
          <td align='center'></td>
          <td align='center'>{infoFila.lado}</td>
          <td align='center'>{infoFila.combustible}</td>
          <td>
            <Form.InputText
              value={arrayActualSalidaInput[i]}
              id={`saldo-actualId-${i}`}
              name={`saldo-actual-${i}`}
              onChange={e => handleChange(e, i)}
            />
          </td>
          <td align='center'>{parseFloat(infoFila.saldoAnterior).toFixed(3)}</td>
          <td align='center'>
            {parseFloat(arrayActualSalidaInput[i] ? arrayActualSalidaInput[i] - infoFila.saldoAnterior : infoFila.saldoAnterior).toFixed(3)}
          </td>
          <td align='center'>{parseFloat(montoVentaRecuperada).toFixed(3)}</td>
          <td align='center'>
            {parseFloat(
              montoVentaRecuperada - (arrayActualSalidaInput[i] ? arrayActualSalidaInput[i] - infoFila.saldoAnterior  : infoFila.saldoAnterior)
            ).toFixed(3)}
          </td>
        </tr>
      )
    }
  }
  return salida
}

export default React.memo(RowTemplate)
